export const categories = [
  { id: 'wanfa-jiqiao', name: '玩法技巧', icon: 'ri-gamepad-line', desc: '掌握核心操作技巧，提升游戏实力' },
  { id: 'guanka-gonglue', name: '关卡攻略', icon: 'ri-map-pin-line', desc: '逐关突破，轻松通关每一关' },
  { id: 'gaofen-miji', name: '高分秘籍', icon: 'ri-trophy-line', desc: '冲击排行榜，获取最高分数' },
  { id: 'xinshou-jiaocheng', name: '新手教程', icon: 'ri-user-star-line', desc: '从零开始，快速上手踩蘑菇' },
  { id: 'jinjie-jiqiao', name: '进阶技巧', icon: 'ri-rocket-line', desc: '高手进阶，发掘隐藏玩法' },
  { id: 'yincang-yaosu', name: '隐藏要素', icon: 'ri-eye-2-line', desc: '揭秘彩蛋与隐藏关卡' },
];

export const articles = [
  {
    id: 1,
    title: '踩蘑菇新手必读：从零开始掌握核心操作',
    slug: 'xinshou-bidu-hexin-caozuo',
    category: 'xinshou-jiaocheng',
    excerpt: '刚接触踩蘑菇不知道从何下手？本文从基础移动、跳跃技巧到蘑菇识别，手把手带你入门这款经典游戏。',
    difficulty: '初级',
    author: '蘑菇达人',
    date: '2026-07-28',
    readTime: '8分钟',
    imageSeq: 'article-01',
    viewCount: 15280,
    content: [
      { type: 'heading', level: 2, text: '一、什么是踩蘑菇游戏？' },
      { type: 'paragraph', text: '踩蘑菇是一款经典的横版跳跃类小游戏，玩家需要操控角色在不同的平台上跳跃，踩踏蘑菇敌人获取分数，同时避开危险的怪物和障碍物。游戏以其简单易上手的操作和富有挑战性的关卡设计，吸引了各年龄段的玩家。游戏的核心乐趣在于精准的时机把握和对关卡地形的熟悉程度。' },
      { type: 'heading', level: 2, text: '二、基本操作介绍' },
      { type: 'paragraph', text: '踩蘑菇的操作非常简单直观：使用方向键或WASD控制角色左右移动，空格键或上方向键进行跳跃。连按两次跳跃键可以实现二段跳，这是在面对高台和复杂地形时的重要技巧。踩在蘑菇敌人头顶即可消灭它们并获得分数，不同颜色的蘑菇分值各不相同。' },
      { type: 'heading', level: 3, text: '2.1 移动技巧' },
      { type: 'paragraph', text: '移动时要善用惯性系统，角色在奔跑过程中会逐渐加速，利用这个特点可以在远距离跳跃时获得更好的效果。同时要注意急停和转向的时机，避免因为惯性而掉落平台。' },
      { type: 'heading', level: 3, text: '2.2 跳跃进阶' },
      { type: 'paragraph', text: '跳跃不只是按空格那么简单。轻按和长按跳跃键会产生不同的跳跃高度。在平台边缘起跳可以增加跳跃距离，这个技巧在后期关卡中至关重要。此外，踩中敌人的同时按下跳跃键可以实现反弹跳，这是获得额外高度的绝佳方式。' },
      { type: 'heading', level: 2, text: '三、蘑菇种类详解' },
      { type: 'paragraph', text: '游戏中主要有四种蘑菇：红色蘑菇（基础分数100分）、金色蘑菇（分数200分，会移动）、紫色蘑菇（分数500分，具有攻击性）、还有稀有的彩虹蘑菇（分数1000分，出现概率极低）。了解每种蘑菇的特性是获得高分的关键。' },
      { type: 'heading', level: 2, text: '四、新手常见问题' },
      { type: 'paragraph', text: '很多新手玩家反映在第三关就卡住了，主要原因是不知道如何利用移动平台。当平台移动到你正下方时再起跳，而不是提前跳跃。另外，不要贪心去踩每一个蘑菇，有时绕过敌人反而更安全高效。记住这些要点，相信你很快就能通关前五关！' },
    ],
  },
  {
    id: 2,
    title: '第一关至第五关详细通关攻略',
    slug: 'guanqia-1-5-tongguan-gonglue',
    category: 'guanka-gonglue',
    excerpt: '前五关是踩蘑菇的入门关卡，本文详细解析每一关的地形特点、敌人分布和通关要点，让你轻松突破前期关卡。',
    difficulty: '初级',
    author: '通关达人',
    date: '2026-07-25',
    readTime: '12分钟',
    imageSeq: 'article-02',
    viewCount: 23100,
    content: [
      { type: 'heading', level: 2, text: '关卡总览' },
      { type: 'paragraph', text: '踩蘑菇的前五关是整个游戏的基础，每一关都引入了新的机制和挑战。第一关学习基础操作，第二关引入移动平台，第三关出现紫色蘑菇，第四关增加了陷阱地形，第五关则是前期的一个小Boss关。下面我们逐一解析。' },
      { type: 'heading', level: 2, text: '第一关：翠绿草原' },
      { type: 'paragraph', text: '作为游戏的第一个关卡，翠绿草原设计得非常友好。整个关卡只有红色蘑菇，没有会移动的敌人。你需要做的是熟悉基本移动和跳跃操作。建议在这一关反复练习跳跃的力度控制，为后续关卡打好基础。完美通关（收集全部蘑菇）可获得额外500分奖励。' },
      { type: 'heading', level: 2, text: '第二关：移动浮桥' },
      { type: 'paragraph', text: '从第二关开始，游戏中出现了会左右移动的平台。关键要点是观察平台的移动规律——每个移动平台都有固定的移动范围和速度。站在移动平台上时不要慌张，等它移动到最靠近目的地的位置再起跳。本关还首次出现了金币蘑菇，记得收集！' },
      { type: 'heading', level: 2, text: '第三关：迷雾森林' },
      { type: 'paragraph', text: '第三关是很多玩家的第一个难点。紫色蘑菇首次出现，它会主动追击玩家。对付紫色蘑菇的最佳策略是从高处踩踏，或者利用地形引诱它掉入陷阱。本关还有一个隐藏的彩虹蘑菇，位于第三棵大树后面，需要利用反弹跳才能到达。' },
      { type: 'heading', level: 2, text: '第四关：岩浆洞穴' },
      { type: 'paragraph', text: '岩浆洞穴中地面有间歇性喷发的火焰陷阱。观察火焰喷发的规律——每次喷发持续2秒，间隔3秒。利用这个时间窗口快速通过危险区域。本关的金色蘑菇位置非常刁钻，需要连续使用三次反弹跳才能到达，建议先在安全区域练习反弹跳技巧。' },
      { type: 'heading', level: 2, text: '第五关：蘑菇城堡大门' },
      { type: 'paragraph', text: '第五关是进入城堡前的最后挑战。关底有一个大型蘑菇守卫，不能直接踩踏，需要先踩下场景中的三个开关使其虚弱。三个开关分布在地图的左、中、右三个区域，建议从左到右依次激活。击败守卫后可获得一个额外的生命值奖励。' },
    ],
  },
  {
    id: 3,
    title: '踩蘑菇高分攻略：冲击排行榜的十大技巧',
    slug: 'gaofen-gonglue-shi-da-jiqiao',
    category: 'gaofen-miji',
    excerpt: '想让名字出现在排行榜前列？本文总结了十大得分技巧，从蘑菇连击到隐藏分数区域，助你轻松拿下高分。',
    difficulty: '中级',
    author: '高分猎人',
    date: '2026-07-22',
    readTime: '10分钟',
    imageSeq: 'article-03',
    viewCount: 18950,
    content: [
      { type: 'heading', level: 2, text: '连击系统深度解析' },
      { type: 'paragraph', text: '踩蘑菇的连击系统是获取高分的核心机制。连续踩踏蘑菇而不落地，每次连击分数会递增：100、200、400、800、1600……最高可达10连击获得51200分。要实现高连击，需要提前规划路线，利用墙壁反弹和移动平台维持高度。' },
      { type: 'heading', level: 2, text: '1. 路线规划法' },
      { type: 'paragraph', text: '在进入每一关之前，先观察蘑菇的位置分布。理想的路线应该让蘑菇之间的间距恰好适合一次跳跃的距离。如果中间有空隙，考虑利用墙壁弹跳来过渡。' },
      { type: 'heading', level: 2, text: '2. 彩虹蘑菇定位' },
      { type: 'paragraph', text: '每个关卡都有一个隐藏的彩虹蘑菇，踩中可得1000分并触发10秒的双倍分数模式。以下是前五关的彩虹蘑菇位置：第一关-瀑布后方、第二关-最高浮动平台的右上角、第三关-第三棵大树后、第四关-岩浆瀑布上方、第五关-Boss房左上角。' },
      { type: 'heading', level: 2, text: '3. 时间奖励最大化' },
      { type: 'paragraph', text: '每关通关后剩余的时间会转换为分数（每秒50分）。因此，不仅要收集蘑菇，还要尽量快速通关。建议在熟悉关卡布局后尝试速通，结合时间奖励和蘑菇分数双管齐下。' },
      { type: 'heading', level: 2, text: '更多高分技巧' },
      { type: 'paragraph', text: '除了以上核心技巧，还需注意：不要浪费反弹跳机会、善用惯性加速跨越长距离间隙、在双倍分数时间内优先踩高价值蘑菇、每关结束时观察是否有遗漏的隐藏区域。综合运用这些技巧，你的分数一定能大幅提升！' },
    ],
  },
  {
    id: 4,
    title: '踩蘑菇进阶技巧：反弹跳、踩墙跳全掌握',
    slug: 'jinjie-jiqiao-fantan-caiqiang',
    category: 'jinjie-jiqiao',
    excerpt: '反弹跳和踩墙跳是区分普通玩家和高手的标志性技巧。本文通过详细图解和实操步骤，帮助你真正掌握这些高级操作。',
    difficulty: '高级',
    author: '技术流玩家',
    date: '2026-07-19',
    readTime: '15分钟',
    imageSeq: 'article-04',
    viewCount: 11230,
    content: [
      { type: 'heading', level: 2, text: '反弹跳原理' },
      { type: 'paragraph', text: '反弹跳是踩蘑菇中最重要的进阶技巧。当角色踩中蘑菇的瞬间按下跳跃键，可以触发一次额外的跳跃，这次跳跃的高度是普通跳跃的1.5倍。熟练掌握反弹跳可以让你到达正常跳跃无法抵达的高台区域。' },
      { type: 'heading', level: 2, text: '反弹跳练习步骤' },
      { type: 'paragraph', text: '第一步：找一只红色蘑菇作为练习对象。第二步：正常起跳并落在蘑菇上方。第三步：在落地瞬间（约0.1秒窗口期）再次按下跳跃键。成功时会看到角色以一个更高的弧线弹起，并且会有一个特殊的光效提示。建议在第二关练习，因为那里有较多的蘑菇和宽敞的练习空间。' },
      { type: 'heading', level: 2, text: '踩墙跳技巧' },
      { type: 'paragraph', text: '踩墙跳允许角色在接触墙壁时进行一次额外的跳跃。操作方法是：跳向墙壁，在接触墙壁的瞬间按下与墙壁相反的方向键加跳跃键。这个技巧在狭窄的垂直通道中特别有用。连续踩墙跳可以爬上任何高度的墙壁。' },
      { type: 'heading', level: 2, text: '组合技巧：无限攀爬' },
      { type: 'paragraph', text: '将反弹跳和踩墙跳结合起来，可以实现理论上无限的高度攀升。在两堵面对面的墙壁之间交替使用踩墙跳，同时利用空中的蘑菇进行反弹跳补充高度。这个组合技巧是到达游戏最高隐藏区域的唯一方法。' },
    ],
  },
  {
    id: 5,
    title: '揭秘踩蘑菇十大隐藏彩蛋和隐藏关卡',
    slug: 'yincang-caidan-yincang-guanka',
    category: 'yincang-yaosu',
    excerpt: '踩蘑菇中藏着大量开发者留下的彩蛋和隐藏关卡，从致敬经典的像素画到完全颠覆玩法的隐藏世界，这些秘密等你来发现！',
    difficulty: '中级',
    author: '彩蛋猎人',
    date: '2026-07-16',
    readTime: '14分钟',
    imageSeq: 'article-05',
    viewCount: 27600,
    content: [
      { type: 'heading', level: 2, text: '隐藏关卡入口汇总' },
      { type: 'paragraph', text: '游戏中存在三个隐藏关卡，分别需要满足特定条件才能进入：倒置世界（在第三关的特定位置静止5秒）、像素怀旧关（集齐所有彩虹蘑菇后自动触发）、蘑菇王国（在第五关Boss房左侧隐藏墙壁进入）。每个隐藏关卡的玩法风格都截然不同，非常值得探索。' },
      { type: 'heading', level: 2, text: '彩蛋一：开发者房间' },
      { type: 'paragraph', text: '在第四关岩浆洞穴的最深处，有一个需要利用连续踩墙跳才能到达的隐藏区域。进入后会看到一个装饰成办公室的小房间，墙上挂着开发团队的照片，桌上还有游戏设计手稿。站在照片前按下交互键还能看到一段开发者的留言。' },
      { type: 'heading', level: 2, text: '彩蛋二：经典游戏致敬' },
      { type: 'paragraph', text: '像素怀旧关中，整个画面会变成8-bit风格，背景音乐会切换为经典的芯片音乐。这一关的设计致敬了80年代的经典横版游戏，关卡中隐藏着多个知名游戏角色的像素化形象。找到所有像素角色可获得"游戏考古学家"成就。' },
      { type: 'heading', level: 2, text: '更多隐藏发现' },
      { type: 'paragraph', text: '此外还有：输入特定按键组合（上上下下左右左右BA）可解锁无限跳跃模式、在主菜单等待三分钟会看到蘑菇跳舞动画、完成所有关卡后标题画面蘑菇会戴上皇冠。这些细节充满了开发者对游戏的热爱，等待每一位细心的玩家去发现。' },
    ],
  },
  {
    id: 6,
    title: '第六关至第十关完整攻略：挑战升级',
    slug: 'guanqia-6-10-wanzheng-gonglue',
    category: 'guanka-gonglue',
    excerpt: '通过前五关的考验后，第六至第十关将带来全新的挑战。镜像世界、重力反转、时间限制等新机制等你来征服。',
    difficulty: '高级',
    author: '通关达人',
    date: '2026-07-14',
    readTime: '16分钟',
    imageSeq: 'article-06',
    viewCount: 9820,
    content: [
      { type: 'heading', level: 2, text: '第六关：镜像迷宫' },
      { type: 'paragraph', text: '第六关引入了镜像机制，上下左右全部反转。刚开始可能会非常不适应，建议先在安全区域练习反向操作。本关的蘑菇会模仿玩家的动作——你跳它也跳，你需要预判它的位置来踩踏。通关秘诀：先停下来观察蘑菇的移动模式，不要急于行动。' },
      { type: 'heading', level: 2, text: '第七关：云端之城' },
      { type: 'paragraph', text: '云端之城的平台会逐渐消失，站在一个平台上超过3秒它就会开始透明化并在1秒后完全消失。你需要不停地移动和跳跃。好消息是本关没有敌人，但平台消失的机制让通关节奏非常紧凑。建议按逆时针方向绕圈移动。' },
      { type: 'heading', level: 2, text: '第八关：重力反转工厂' },
      { type: 'paragraph', text: '重力反转工厂中有多个重力场区域，角色进入后会贴在天花板上行走。在重力转换的瞬间要特别注意方向感，很多玩家就是在这里迷失方向掉入深渊的。记住一个口诀：进入重力场前先确认目标位置，进入后立即调整方向。' },
      { type: 'heading', level: 2, text: '第九关：时间神殿' },
      { type: 'paragraph', text: '时间神殿有严格的时间限制——3分钟内必须通关。关卡中散布着可以增加时间的蓝色蘑菇（+15秒）和减少时间的红色骷髅（-20秒）。最佳路线是从左下角出发，沿S形路线收集所有加时蘑菇，避开红色骷髅。' },
      { type: 'heading', level: 2, text: '第十关：最终Boss——蘑菇之王' },
      { type: 'paragraph', text: '作为前期关卡的最终Boss，蘑菇之王有三个阶段。第一阶段：它会跳跃并产生冲击波，跳起躲避即可。第二阶段：召唤小蘑菇助战，利用反弹跳在小蘑菇之间穿梭并反击。第三阶段：狂暴模式，速度大幅提升，此时要灵活运用踩墙跳躲避攻击，并在它疲惫的间隙进行反击。' },
    ],
  },
  {
    id: 7,
    title: '移动端踩蘑菇操作优化指南',
    slug: 'yidongduan-caozuo-youhua',
    category: 'wanfa-jiqiao',
    excerpt: '在手机上玩踩蘑菇总觉得手感不对？本文分享触屏操作优化、灵敏度设置和手势技巧，让移动端体验媲美手柄操作。',
    difficulty: '初级',
    author: '蘑菇达人',
    date: '2026-07-11',
    readTime: '7分钟',
    imageSeq: 'article-07',
    viewCount: 14560,
    content: [
      { type: 'heading', level: 2, text: '触屏操作布局优化' },
      { type: 'paragraph', text: '默认的触屏按键布局可能不是最适合你的。建议将跳跃按钮放大到1.5倍默认大小，并将其放置在屏幕右下角最舒适的位置。方向控制区可以稍微向上移动，给大拇指更多活动空间。在设置中开启"浮动摇杆"选项，让方向控制更加顺手。' },
      { type: 'heading', level: 2, text: '灵敏度调校' },
      { type: 'paragraph', text: '触屏灵敏度的设置非常个人化，但有一些通用建议：水平灵敏度设置为70-80%，垂直灵敏度保持50%。关闭"惯性滑动"选项可以更精确地控制角色停止位置。开启"轻触跳跃"功能，只需点击屏幕任意位置即可跳跃，解放拇指的同时提高反应速度。' },
    ],
  },
  {
    id: 8,
    title: '踩蘑菇速通纪录解析：大神是怎么做到的？',
    slug: 'sutong-jilu-jiexi',
    category: 'gaofen-miji',
    excerpt: '来看看全球速通排行榜上的大神们是如何在极短时间内通关的。从路线优化到操作细节，每一帧都是技术。',
    difficulty: '高级',
    author: '高分猎人',
    date: '2026-07-08',
    readTime: '11分钟',
    imageSeq: 'article-08',
    viewCount: 20100,
    content: [
      { type: 'heading', level: 2, text: '速通基本原则' },
      { type: 'paragraph', text: '速通（Speedrun）追求的不仅仅是快，更是在极短时间内完成游戏的艺术。踩蘑菇速通的核心在于跳过非必要的蘑菇、利用游戏物理引擎的边缘跳跃Bug、以及精准的路线规划。当前世界纪录为12分37秒完成全部十关。' },
      { type: 'heading', level: 2, text: '关键技巧：边缘跳跃Bug' },
      { type: 'paragraph', text: '在平台的最边缘（角色的脚刚好还在平台上）起跳，可以获得约1.3倍的额外跳跃距离。这个Bug在产品更新中被保留了下来，因为开发者认为这增加了游戏的技术深度。掌握边缘跳跃可以将很多关卡的通关时间缩短20%以上。' },
      { type: 'heading', level: 2, text: '最优路线规划' },
      { type: 'paragraph', text: '速通选手使用的路线和普通玩家完全不同。以第四关为例，速通路线会跳过60%的蘑菇，只收集加速和加时道具。关键是利用岩浆喷发的间歇通过危险区域，同时在移动平台上进行跳跃接力——一次跳跃跨越两个平台，节省大量时间。' },
    ],
  },
  {
    id: 9,
    title: '踩蘑菇常见Bug与解决方法汇总',
    slug: 'changjian-bug-jiejue-fangfa',
    category: 'wanfa-jiqiao',
    excerpt: '游戏过程中遇到角色卡住、分数不显示等问题？本文整理踩蘑菇最常见的Bug及其解决方案，帮你快速恢复正常游戏。',
    difficulty: '初级',
    author: '蘑菇达人',
    date: '2026-07-05',
    readTime: '6分钟',
    imageSeq: 'article-09',
    viewCount: 32500,
    content: [
      { type: 'heading', level: 2, text: '常见问题一：角色卡在墙里' },
      { type: 'paragraph', text: '如果在使用踩墙跳时不小心卡进了墙壁内部，无需重新开始。连续快速按下左右方向键3-5次，角色会自动弹回最近的平台。如果这个方法无效，在暂停菜单中选择"重置角色位置"即可。' },
      { type: 'heading', level: 2, text: '常见问题二：分数不更新' },
      { type: 'paragraph', text: '偶尔会出现分数显示不同步的问题。这通常是网络延迟导致的本地数据未及时上传。解决方法：在设置中点击"手动同步数据"，通常等待几秒即可恢复正常显示。如果问题持续，可以尝试清除游戏缓存。' },
      { type: 'heading', level: 2, text: '常见问题三：音效不同步' },
      { type: 'paragraph', text: '在某些设备上，跳跃音效和实际动作会有0.2-0.5秒的延迟。进入设置→音频→音频延迟补偿，调整数值直到音效与动作同步。一般设置在50-100ms之间即可解决问题。' },
    ],
  },
  {
    id: 10,
    title: '隐藏关卡全攻略：倒置世界与蘑菇王国',
    slug: 'yincang-guanka-daozhi-shijie',
    category: 'yincang-yaosu',
    excerpt: '深入探索两个最神秘的隐藏关卡——倒置世界和蘑菇王国，从入口条件到通关路线，最全隐藏关卡攻略在这里。',
    difficulty: '高级',
    author: '彩蛋猎人',
    date: '2026-07-02',
    readTime: '13分钟',
    imageSeq: 'article-10',
    viewCount: 16500,
    content: [
      { type: 'heading', level: 2, text: '隐藏关卡一：倒置世界' },
      { type: 'paragraph', text: '进入条件：在第三关的特定位置（坐标X:245, Y:320，第三棵大树后方的隐藏平台）静止站立5秒，屏幕会开始旋转并进入倒置世界。在这个关卡中，重力方向完全相反，你需要在"天花板"上移动，这对方向感是极大的考验。' },
      { type: 'heading', level: 2, text: '倒置世界通关路线' },
      { type: 'paragraph', text: '倒置世界只有一条路，但充满了逆向思维的设计。第一个难点是在倒置的瀑布中穿行——水流方向是从下往上的，你需要对抗水流向下移动。第二个难点是倒置蘑菇的行为模式完全改变，它们会主动从上方来撞击你。通关奖励：获得"颠倒乾坤"成就。' },
      { type: 'heading', level: 2, text: '隐藏关卡二：蘑菇王国' },
      { type: 'paragraph', text: '进入条件：在第五关Boss房，击败蘑菇守卫后不要立即进入城堡大门，而是走到房间左侧墙壁，使用踩墙跳爬到顶部，会发现一个隐藏入口。蘑菇王国是一个完全不同的世界——这里没有敌人，所有蘑菇都是友好的NPC。' },
      { type: 'heading', level: 2, text: '蘑菇王国探索要点' },
      { type: 'paragraph', text: '蘑菇王国有三个区域：蘑菇市集（可以购买永久升级道具）、蘑菇学院（学习新技能的地方）、蘑菇皇宫（接受蘑菇国王的任务，完成后获得最强装备"黄金蘑菇靴"）。每个NPC都有独特的对话内容，部分对话还隐藏着下个版本更新的线索。' },
    ],
  },
  {
    id: 11,
    title: '踩蘑菇全套成就获取指南',
    slug: 'chengjiu-huode-zhinan',
    category: 'jinjie-jiqiao',
    excerpt: '踩蘑菇共有42个成就等待解锁，从简单的"初次踩踏"到极限难度的"无伤通关"，本文提供所有成就的完整解锁条件。',
    difficulty: '中级',
    author: '技术流玩家',
    date: '2026-06-29',
    readTime: '18分钟',
    imageSeq: 'article-11',
    viewCount: 8900,
    content: [
      { type: 'heading', level: 2, text: '成就系统概览' },
      { type: 'paragraph', text: '踩蘑菇共有42个成就，分为五个等级：青铜（15个）、白银（12个）、黄金（8个）、铂金（5个）、钻石（2个）。完成所有成就可获得"蘑菇大师"终极称号，并在个人主页上显示特殊边框。' },
      { type: 'heading', level: 2, text: '最稀有成就：无伤通关' },
      { type: 'paragraph', text: '钻石成就"钢铁蘑菇"要求全程不受任何伤害完成全部十关，目前全球仅有0.02%的玩家解锁。建议的达成策略：先在每关单独练习无伤通关，然后逐步尝试连续通关。前五关相对容易，后五关需要大量练习。利用第八关重力反转中的安全区域恢复心态也很重要。' },
      { type: 'heading', level: 2, text: '隐藏成就列表' },
      { type: 'paragraph', text: '除了明面上的成就，还有5个隐藏成就不会在列表显示：在主菜单发呆5分钟、在所有关卡中故意掉落100次、连续踩同一个蘑菇10次（它会被踩扁并出现特殊动画）、在倒置世界中站立不动一直到背景音乐放完一遍、以及最神秘的"与开发者对话"成就。' },
    ],
  },
  {
    id: 12,
    title: '踩蘑菇各版本差异对比：选对版本玩得更爽',
    slug: 'banben-chayi-duibi',
    category: 'xinshou-jiaocheng',
    excerpt: '踩蘑菇有经典版、重制版、手游版等多个版本，每个版本在手感、内容和画质上都有所不同。本文帮你选到最适合的版本。',
    difficulty: '初级',
    author: '通关达人',
    date: '2026-06-26',
    readTime: '9分钟',
    imageSeq: 'article-12',
    viewCount: 7600,
    content: [
      { type: 'heading', level: 2, text: '经典版（2018）' },
      { type: 'paragraph', text: '经典版是踩蘑菇最初发布的版本，像素风格的画面充满了怀旧感。这个版本的物理引擎最为"硬核"——跳跃高度完全取决于按键时长，没有任何辅助功能。适合追求原汁原味体验的硬核玩家。目前经典版在Windows和Mac平台上可以免费游玩。' },
      { type: 'heading', level: 2, text: '重制版（2023）' },
      { type: 'paragraph', text: '重制版对画面进行了全面升级，从像素风变成了精美的手绘风格。新增了三个关卡、在线排行榜和每日挑战模式。物理引擎也经过了优化，操作手感更加流畅。引入了"辅助模式"选项，可以开启跳跃辅助线，大幅降低新手门槛。推荐大多数玩家选择这个版本。' },
      { type: 'heading', level: 2, text: '手游版（2024）' },
      { type: 'paragraph', text: '手游版针对触屏操作进行了专门优化，包含自动奔跑、虚拟摇杆和自定义按键布局等功能。支持云存档同步，可以在手机和平板之间切换游玩。手游版还加入了社交功能，可以和好友比拼分数。唯一的缺点是部分高级操作在触屏上较难实现。' },
    ],
  },
];

export const difficultyColors: Record<string, string> = {
  '初级': 'bg-accent-100 text-accent-700',
  '中级': 'bg-secondary-100 text-secondary-700',
  '高级': 'bg-primary-100 text-primary-700',
};